import api from './api';

class ClauseService {
  // Get all clauses
  static async getClauses(params = {}) {
    try {
      const response = await api.get('/clauses', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching clauses:', error);
      throw this.handleError(error);
    }
  }

  // Get clause by ID
  static async getClauseById(id) {
    try {
      const response = await api.get(`/clauses/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching clause:', error);
      throw this.handleError(error);
    }
  }

  // Create new clause
  static async createClause(clauseData) {
    try {
      const response = await api.post('/clauses', clauseData);
      return response.data;
    } catch (error) {
      console.error('Error creating clause:', error);
      throw this.handleError(error);
    }
  }

  // Update clause
  static async updateClause(id, clauseData) {
    try {
      const response = await api.put(`/clauses/${id}`, clauseData);
      return response.data;
    } catch (error) {
      console.error('Error updating clause:', error);
      throw this.handleError(error);
    }
  }

  // Delete clause
  static async deleteClause(id) {
    try {
      const response = await api.delete(`/clauses/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting clause:', error);
      throw this.handleError(error);
    }
  }

  // Get clauses by category
  static async getClausesByCategory(category) {
    try {
      const response = await api.get(`/clauses/category/${category}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching clauses by category:', error);
      throw this.handleError(error);
    }
  }

  // Search clauses
  static async searchClauses(query) {
    try {
      const response = await api.get('/clauses/search', { params: { q: query } });
      return response.data;
    } catch (error) {
      console.error('Error searching clauses:', error);
      throw this.handleError(error);
    }
  }

  // Get clause packs
  static async getClausePacks() {
    try {
      const response = await api.get('/clauses/packs');
      return response.data;
    } catch (error) {
      console.error('Error fetching clause packs:', error);
      throw this.handleError(error);
    }
  }

  // Create clause pack
  static async createClausePack(packData) {
    try {
      const response = await api.post('/clauses/packs', packData);
      return response.data;
    } catch (error) {
      console.error('Error creating clause pack:', error);
      throw this.handleError(error);
    }
  }

  // Add clause to pack
  static async addClauseToPack(packId, clauseId) {
    try {
      const response = await api.post(`/clauses/packs/${packId}/clauses`, { clauseId });
      return response.data;
    } catch (error) {
      console.error('Error adding clause to pack:', error);
      throw this.handleError(error);
    }
  }

  // Generate AI clause
  static async generateAIClause(prompt, context = {}) {
    try {
      const response = await api.post('/clauses/ai/generate', { prompt, context });
      return response.data;
    } catch (error) {
      console.error('Error generating AI clause:', error);
      throw this.handleError(error);
    }
  }

  // Analyze clause risk
  static async analyzeClauseRisk(clauseContent) {
    try {
      const response = await api.post('/clauses/ai/analyze-risk', { content: clauseContent });
      return response.data;
    } catch (error) {
      console.error('Error analyzing clause risk:', error);
      throw this.handleError(error);
    }
  }

  // Get clause versions
  static async getClauseVersions(clauseId) {
    try {
      const response = await api.get(`/clauses/${clauseId}/versions`);
      return response.data;
    } catch (error) {
      console.error('Error fetching clause versions:', error);
      throw this.handleError(error);
    }
  }

  // Create clause version
  static async createClauseVersion(clauseId, versionData) {
    try {
      const response = await api.post(`/clauses/${clauseId}/versions`, versionData);
      return response.data;
    } catch (error) {
      console.error('Error creating clause version:', error);
      throw this.handleError(error);
    }
  }

  // Error handler
  static handleError(error) {
    if (error.response) {
      // Server responded with error status
      return {
        success: false,
        message: error.response.data?.message || 'An error occurred',
        status: error.response.status
      };
    } else if (error.request) {
      // Request was made but no response received
      return {
        success: false,
        message: 'Network error - please check your connection',
        status: 0
      };
    } else {
      // Something else happened
      return {
        success: false,
        message: error.message || 'An unexpected error occurred',
        status: 0
      };
    }
  }
}

export default ClauseService;
